import React from 'react'
import styled from 'styled-components'
import Colors from '../../../constants/Colors'
import { IconBin } from '../../../constants/icons'

const NotFoundPrize = ({ lotteries, notFoundPrize, setLotteries, handleClickRemoveSomeLottery }) => {

  const handleRemoveAllNotPrize = () => {
    const newLotteries = lotteries.filter((lotto) => lotto.isPrize === true)

    setLotteries(newLotteries)
  }

  return (
    <NotFoundPrizeContent>
      <div className="prize-header">
        <div className="prize-title">ไม่ถูกรางวัล ทั้งหมด {notFoundPrize.length} ใบ</div>
        <button onClick={handleRemoveAllNotPrize} className="remove-prizes">ลบตัวเลขที่ไม่ถูกรางวัลทั้งหมด</button>
      </div>
      <div className="prize-content">
        {notFoundPrize.map((prize) => {
          return (
            <div key={prize.lotteryId} className="prize-box" >
              <div className="prize-overlay-color" onClick={() => handleClickRemoveSomeLottery(prize.index)} >
                <span className="prize-icon-box">
                  <IconBin fill={Colors.WHITE} />
                </span>
                <div className="prize-overlay" />
                <img src={prize.url} alt="not found prize" className="prize-image" />
              </div>
              <div className="prize-lotttery-id">{prize.lotteryId}</div>
            </div>
          )
        })}
      </div>
    </NotFoundPrizeContent>
  )
}

export default NotFoundPrize

const NotFoundPrizeContent = styled.div`
  .prize-header {
    display: flex;
    justify-content: space-between;
    margin: 1em 0 1em 0;
    
    .prize-title {
      font-family: Prompt-SemiBold;
      line-height: 24px;
      font-size: 16px;
      flex: 1;
    }

    .remove-prizes {
      flex: 1;
      font-size: 1em;
      font-weight: bold;
      padding: 0.25em 1em;
      border-radius: 3px;
      color: ${Colors.WHITE};
      border: 2px solid ${Colors.LIGHT_RED};
      background-color: ${Colors.LIGHT_RED};

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      &:active {
        opacity: 0.8;
        color: ${Colors.SUPER_BLACK};
      }
    }
  }
  
  .prize-content {
    margin-top: 24px;
    margin-bottom: 56px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;

    .prize-box {
      width: 24%;
      height: 24%;
      margin-bottom: 24px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid ${Colors.LIGHT_GREY2};
      background-color: ${Colors.SOFT_WHITE};

      .prize-overlay-color {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .prize-icon-box {
          position: absolute;
          display: none;
          z-index: 1;
        }

        .prize-overlay {
          display: none;
          border-radius: 8px;
          opacity: 0.5;
          width: 100%;
          height: 100%;
          position: absolute;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          background-color: ${Colors.SUPER_BLACK};
        }

        .prize-image {
          width: 100%;
          border-radius: 8px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:hover {
          cursor: pointer;
          
          .prize-overlay {
            display: block;
          }

          .prize-icon-box {
            display: block;
          }
        }
      }

      .prize-lotttery-id {
        box-sizing: border-box;
        font-size: 16px;
        font-weight: normal;
        width: 100%;
        margin: 4px 0;
        text-align: center;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        color: ${Colors.DARK_GREY};
      }
    }
  }
`
